import React from 'react';
import { ErrorHandler, Gutter, Tabs } from '@common/components';
import { MissionControlBasePage } from '@institutions/pages';
import { MissionControlComplianceTable } from './_mission-control-compliance-table';
import { useNavigate, useQuery, useParams } from '@common/hooks';
import { MISSION_CONTROL_COMPLIANCE_COUNTERS_QUERY } from '@working-experience/graphql/queries';
import { ComplianceTable } from '@onboarding/components';

const { Tab, Pane } = Tabs;

export function MissionControlCompliancePage() {
  const { selectedTab } = useParams<{ selectedTab: string }>();
  const navigate = useNavigate();
  const { data: countsData, error } = useQuery(
    MISSION_CONTROL_COMPLIANCE_COUNTERS_QUERY
  );

  if (error) {
    return <ErrorHandler error={error} log="MissionControlCompliancePage" />;
  }

  const counts = countsData?.missionControlComplianceCounters;
  const missingCount = counts?.missingComplianceCandidates || 0;
  const expiringCount = counts?.expiringDocuments || 0;
  const expiredCount = counts?.expiredDocuments || 0;

  return (
    <MissionControlBasePage section="compliance">
      <Tabs
        defaultActiveKey={selectedTab}
        onTabClick={(key) =>
          navigate(`/works/home/compliance/${key}`, { replace: true })
        }
      >
        <Pane
          tab={<Tab title="Missing Compliance" count={missingCount} />}
          key="missing"
        >
          <Gutter size="lg" direction="vertical">
            <MissionControlComplianceTable complianceStatus="missing" />
          </Gutter>
        </Pane>
        <Pane
          tab={<Tab title="Expiring" count={expiringCount} />}
          key="expiring"
        >
          <Gutter size="lg" direction="vertical">
            <ComplianceTable
              entity="organization"
              defaultFilter={{
                assignmentState: ['onboarding', 'cleared', 'working'],
                expiringSoon: true,
              }}
              defaultOrder={{
                complianceState: 'ascend',
                expiresOn: 'ascend',
              }}
              filterKey="complianceTableExpiring"
            />
          </Gutter>
        </Pane>
        <Pane tab={<Tab title="Expired" count={expiredCount} />} key="expired">
          <Gutter size="lg" direction="vertical">
            <ComplianceTable
              entity="organization"
              defaultFilter={{
                assignmentState: ['onboarding', 'cleared', 'working'],
                expired: true,
              }}
              defaultOrder={{
                complianceState: 'ascend',
                expiresOn: 'ascend',
              }}
              filterKey="complianceTableExpired"
            />
          </Gutter>
        </Pane>
      </Tabs>
    </MissionControlBasePage>
  );
}
